module.exports = __webpack_public_path__ + "static/media/chart1_data.8ac4896f.csv";